import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'noSanitize' })
export class NoSanitizePipe implements PipeTransform {
  private domSanitizer = inject(DomSanitizer);
  /**
   * @description transforms the value in order to prevent sanitization from
   * Angular and render element with regard of alignment made in angular-editor
   * @param {string} html - text for article
   * @returns {SafeHtml}
   */
  public transform(html: string): SafeHtml {
    return this.domSanitizer.bypassSecurityTrustHtml(html);
  }
}
